// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__3VAXz","choiceBoxes":"toolbarselects_choiceBoxes__2SFPY","simpleField":"toolbarselects_simpleField__3MXHu"};